"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = root;
var _effects = require("redux-saga/effects");
var _sagas = require("../../utils/sagas");
var _axios = _interopRequireDefault(require("axios"));
var _mean = _interopRequireDefault(require("lodash/mean"));
var _types = require("../app/types");
var _selectors = require("./selectors");
var _constants = require("./constants");
var _types2 = require("./types");
var _actions = require("./actions");
var _constants2 = require("../websocket/constants");
var _types3 = require("../websocket/types");
var _callbacks = _interopRequireDefault(require("../../callbacks"));
var _config = _interopRequireDefault(require("../../config"));
var _i18n = _interopRequireDefault(require("../../utils/i18n"));
var _logger = _interopRequireDefault(require("../../utils/logger"));
var _manager = _interopRequireDefault(require("../websocket/manager"));
var _excluded = ["payload"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
var logger = new _logger.default('saga:networkMonitor');
var currentFetching;
function* startBandwidthEstimator() {
  yield (0, _effects.put)((0, _actions.updateNetworkStatus)({
    bandwidth: {
      processing: true
    }
  }));
  var startAt = Date.now();
  var avgSpeed = 0;
  var counter = 0;
  currentFetching = _axios.default.CancelToken.source();
  logger.log('startBandwidthEstimator');
  if (currentFetching) {
    try {
      yield (0, _axios.default)({
        method: 'get',
        timeout: 60000,
        url: _config.default.networkMonitoring.downloadFile,
        cancelToken: currentFetching.token
      });
      var now = Date.now();
      var delta = (now - startAt) / 1000;
      var dataLoaded = 5 * 1024;
      avgSpeed = dataLoaded / delta;
    } catch (e) {}
    logger.log('stats', {
      avgSpeed,
      windowCount: counter
    });
    yield (0, _effects.put)((0, _actions.updateNetworkStatus)({
      bandwidth: {
        down: avgSpeed,
        estimatedAt: Date.now(),
        processing: false
      }
    }));
    currentFetching = null;
  }
}
function* cancelBandwidthEstimator() {
  if (currentFetching) {
    logger.log('cancelBandwidthEstimator');
    try {
      currentFetching.cancel('background');
    } catch (e) {}
  }
}
var fetchUrls = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator(function* (urls) {
    for (var url of urls) {
      try {
        var now = Date.now();
        yield (0, _axios.default)({
          method: 'get',
          url,
          timeout: 3000,
          headers: {
            'Cache-Control': 'no-cache'
          }
        });
        return Date.now() - now;
      } catch (e) {
        logger.log('fetchUrls failed', {
          url
        });
      }
    }
    throw new Error();
  });
  return function fetchUrls(_x) {
    return _ref.apply(this, arguments);
  };
}();
var connectivityLoopLaunched = false;
function connectivityLoop(_ref2) {
  var {
    type
  } = _ref2;
  return function* (_config$networkMonito) {
    if (type === _types.APP_STATE_BACKGROUND) {
      logger.log('connectivityLoop stop');
      connectivityLoopLaunched = false;
      return;
    }
    var reachabilityUrls = _config.default === null || _config.default === void 0 || (_config$networkMonito = _config.default.networkMonitoring) === null || _config$networkMonito === void 0 || (_config$networkMonito = _config$networkMonito.reachability) === null || _config$networkMonito === void 0 ? void 0 : _config$networkMonito.reachabilityUrls;
    if (connectivityLoopLaunched || !(reachabilityUrls !== null && reachabilityUrls !== void 0 && reachabilityUrls.length)) {
      logger.log('connectivityLoop skipped', {
        type
      });
      return;
    }
    connectivityLoopLaunched = true;
    logger.log('connectivityLoop started', {
      type
    });

    // eslint-disable-next-line no-unmodified-loop-condition
    while (connectivityLoopLaunched) {
      var payload = {};
      try {
        yield fetchUrls(reachabilityUrls);
        payload.isInternetReachable = true;
      } catch (e) {
        // do something, Internet is down  😱
        payload.isInternetReachable = false;
        payload.bandwidth = {
          down: 0,
          up: 0,
          estimatedAt: 0
        };
      }
      var previousNetwork = yield (0, _effects.select)(_selectors.all);
      if (payload.isInternetReachable !== previousNetwork.isInternetReachable) {
        yield (0, _effects.put)((0, _actions.updateNetworkStatus)(payload));
        if (!payload.isInternetReachable) {
          // No internet detected
          _callbacks.default.get('showSnackBar')({
            icon: 'warning',
            message: _i18n.default.translate('network.connectivity.error'),
            type: 'danger',
            duration: 5000
          });
        }
      }
      yield (0, _effects.delay)(_config.default.networkMonitoring.reachability.reachabilityLongTimeout);
    }
  }();
}
var networkRtt = {
  min: null,
  max: null,
  mean: null,
  last: null,
  list: []
};
function* calculateQuality(name) {
  try {
    while (true) {
      var _config$networkMonito2;
      var previousNetwork = yield (0, _effects.select)(_selectors.all);
      var isConnected = yield (0, _effects.select)(_selectors.getIsOnlineSelector);
      var isWsOpen = yield (0, _effects.select)(_selectors.getIsWsOpenSelector);
      if (!isConnected || !isWsOpen) {
        logger.debug('calculateQuality:skip', {
          isConnected,
          isWsOpen
        });
      }
      if (isConnected && isWsOpen) {
        var ws = yield (0, _effects.call)(_manager.default.getWs, name);
        var wsSocketId = ws === null || ws === void 0 ? void 0 : ws._id;
        var backendConnectivityRtt = yield (0, _effects.call)(ws === null || ws === void 0 ? void 0 : ws.getRTT);
        if (!backendConnectivityRtt) {
          if (networkRtt.last !== 0) {
            networkRtt.list = [];
            networkRtt.last = 0;
            if (previousNetwork.quality !== _constants.QUALITY.OFFLINE || previousNetwork.wsSocketId !== wsSocketId) {
              yield (0, _effects.put)((0, _actions.updateNetworkStatus)({
                wsSocketId,
                quality: _constants.QUALITY.OFFLINE
              }));
            }
          }
        } else {
          var quality = 0;
          networkRtt.list.push(backendConnectivityRtt);
          var meanRtt = Math.round((0, _mean.default)(networkRtt.list));
          if (meanRtt < 50) {
            quality = _constants.QUALITY.PERFECT;
          } else if (meanRtt < 120) {
            quality = _constants.QUALITY.HIGH;
          } else if (meanRtt < 200) {
            quality = _constants.QUALITY.MEDIUM;
          } else {
            quality = _constants.QUALITY.LOW;
          }
          networkRtt = {
            min: networkRtt.min === null || backendConnectivityRtt < networkRtt.min ? backendConnectivityRtt : networkRtt.min,
            max: networkRtt.max === null || backendConnectivityRtt > networkRtt.max ? backendConnectivityRtt : networkRtt.max,
            mean: meanRtt,
            last: backendConnectivityRtt,
            list: networkRtt.list.slice(-20)
          };
          if (previousNetwork.quality !== quality || previousNetwork.wsSocketId !== wsSocketId) {
            yield (0, _effects.put)((0, _actions.updateNetworkStatus)({
              wsSocketId,
              quality
            }));
          }
        }
      }
      yield (0, _effects.delay)(_config.default === null || _config.default === void 0 || (_config$networkMonito2 = _config.default.networkMonitoring) === null || _config$networkMonito2 === void 0 ? void 0 : _config$networkMonito2.wsRTTInterval);
    }
  } finally {
    if (yield (0, _effects.cancelled)()) logger.debug('calculateQuality:cancelled');
  }
}
var focusTabPattern = isFocused => actions => actions.type === 'SET_TAB_FOCUS' && actions.isFocused === isFocused;
var connectedPattern = isConnected => actions => actions.type === _types2.UPDATE_NETWORK_CONNECTED && actions.isConnected === isConnected;
function handleCalculateQuality(_ref3) {
  var {
      payload: name = _constants2.WEBSOCKET_NAME
    } = _ref3,
    rest = _objectWithoutProperties(_ref3, _excluded);
  return function* (_config$networkMonito3) {
    var isConnected = yield (0, _effects.select)(_selectors.getIsOnlineSelector);
    var isWsOpen = yield (0, _effects.select)(_selectors.getIsWsOpenSelector);
    if (!isConnected || !isWsOpen) {
      logger.debug('handleCalculateQuality:skip', {
        isConnected,
        isWsOpen
      });
      return;
    }
    logger.debug('handleCalculateQuality:start', rest);
    var bgSyncTask = yield (0, _effects.fork)(calculateQuality, name);
    var evt = yield (0, _effects.race)({
      wsClose: (0, _effects.take)(_types3.WS_CLOSE),
      // ws down
      networkUpdate: (0, _effects.take)(connectedPattern(false)),
      // connection down
      tabFocus: (0, _effects.take)(focusTabPattern(false)),
      // tab unfocused
      stopRttStats: (0, _effects.take)(_types2.WS_RTT_STATS_STOP) // manually disable stats
    });

    logger.debug('handleCalculateQuality:end', evt);
    // set delay if tab is focused out (to avoid multiple trigger if user focus multiple times in short period)
    if (evt.tabFocus && _config.default !== null && _config.default !== void 0 && (_config$networkMonito3 = _config.default.networkMonitoring) !== null && _config$networkMonito3 !== void 0 && _config$networkMonito3.wsRTTCountdownOnTabFocusOut) {
      var _config$networkMonito4;
      yield (0, _effects.delay)(_config.default === null || _config.default === void 0 || (_config$networkMonito4 = _config.default.networkMonitoring) === null || _config$networkMonito4 === void 0 ? void 0 : _config$networkMonito4.wsRTTCountdownOnTabFocusOut);
    }
    yield (0, _effects.cancel)(bgSyncTask);
  }();
}
function* websocketStatusSync() {
  var _ws$_primus, _ws$_primus2;
  var ws = yield (0, _effects.call)(_manager.default.getWs, 'api');
  var status = yield (0, _effects.select)(_selectors.getWsStatusSelector);
  if ((ws === null || ws === void 0 || (_ws$_primus = ws._primus) === null || _ws$_primus === void 0 ? void 0 : _ws$_primus.readyStates) !== undefined && (ws === null || ws === void 0 || (_ws$_primus2 = ws._primus) === null || _ws$_primus2 === void 0 ? void 0 : _ws$_primus2.readyState) !== status) {
    logger.warn('WS status in redux is outdated, syncronizing with primus status');
    yield (0, _effects.put)((0, _actions.updateNetworkStatus)({
      backendConnectivityStatus: ws._primus.readyState
    }));
  }
}
function* root() {
  yield (0, _effects.all)([
  // TODO : Find a way to configure them
  (0, _sagas.takeLatest)([_types.APP_STATE_FOREGROUND, _types.APP_STATE_BACKGROUND], connectivityLoop), (0, _sagas.takeLatest)([_types.APP_STATE_FOREGROUND, 'SET_TAB_FOCUS'], websocketStatusSync), (0, _sagas.takeLatest)(_types.APP_STATE_BACKGROUND, cancelBandwidthEstimator), (0, _sagas.takeLatest)(_types2.START_BANDWIDTH_ESTIMATOR, startBandwidthEstimator), (0, _sagas.takeLatest)([_types3.WS_CONNECT, _types2.WS_RTT_STATS_START, focusTabPattern(true)], handleCalculateQuality)]);
}
module.exports = exports.default;